

import { Box, Typography } from '@mui/material';
import MobilePicturesCarousel from '../MobilePicturesPage/MobilePicturesCarousel';


export default function MobileHomePage(){
    return(
        <Box>
            {/* Background carousel image list */}
            <MobilePicturesCarousel />
                
            
            {/* Foreground content */}
            
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    padding: 4,
                    maxWidth: '400px',
                    margin: '0 auto',
                    mt: 8,
                    borderRadius: 2,
                }}
            >
                <Typography>
                    Από το 1984 μεράκι και παράδοση
                </Typography>
                <Typography sx={{m:1}}>
                    Στην καρδιά του Πόρτο Ράφτη μια οικογενεική ταβέρνα "ο Αποστόλης" γεμάτο ιστορία, αυθεντικές γεύσεις, φιλοξενία και.... πολλές αναμνήσεις. <br/> 
                    Εδώ, τίποτα δεν γίνεται βιαστικά, γιατί για εμάς κάθε πιάτο είναι υπόσχεση ότι η παράδοση κρατιέται ζωντανή.
                </Typography>
                <Typography>
                    Καλώς Ορίσατε, <br/>εκεί που η γεύση έχει ιστορία
                </Typography>
            </Box>
        </Box>)
}